import { FC, useMemo, useEffect, useState } from 'react';
import { EuropeSites } from '../../util';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralStore } from '@/components/Referral/ReferralProvider';

interface BannerProps {
    subtitle?: string;
    title: string;
    desc: string;
    children: JSX.Element[] | JSX.Element | boolean;
    isInner?: boolean;
}

const Banner: FC<BannerProps> = ({ subtitle, title, desc, children, isInner = true }) => {
    const { isMobile, useRouter } = useGlobal();
    const { locale, pathname } = useRouter();
    const { pageUsing, actStatus } = useReferralStore();
    const [isUseBg, setIsUseBg] = useState(false);

    const BannerImage = useMemo(() => {
        if (actStatus === null && ['us', 'ca'].includes(locale)) return <></>;
        // 不知道为什么row站点生产渲染此图 添加判断条件试试
        if (pageUsing && pageUsing === 'd3ms' && EuropeSites.includes(locale)) {
            let h5 = 'https://websiteoss.ecoflow.com/figma-uploads/1761562089822-dk2pqe-compressed-01_KV_PC.jpg',
                pc = 'https://websiteoss.ecoflow.com/figma-uploads/1761562122728-7zvx09-compressed-01_KV_M.jpg';

            if (locale === 'uk') {
                pc = 'https://websiteoss.ecoflow.com/upload/image/1767001667226/01_KV_PC.jpg';
                h5 = 'https://websiteoss.ecoflow.com/upload/image/1767001667451/01_KV_M.jpg';
            }

            return <NextImage src={`${!isMobile ? pc : h5}`} alt={title} aria-label={title} />;
        }

        if (EuropeSites.includes(locale)) {
            return (
                <NextImage
                    src={`${
                        !isMobile
                            ? 'https://websiteoss.ecoflow.com/upload/image/1748348838671/kv_pc.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1748348841944/kv_h5.jpg'
                    }`}
                    alt={title}
                    aria-label={title}
                />
            );
        }

        if (pageUsing && pageUsing === 'dp3') {
            return (
                <NextImage
                    src={`${
                        !isMobile
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717055297126/banner_na_pc.jpg'
                            : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717055753775/banner_na_m.jpg'
                    }`}
                    alt={title}
                    aria-label={title}
                />
            );
        }

        const pic = isMobile
            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719213551765/na_dc_banner_m.jpg'
            : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719213546128/na_dc_banner_pc.jpg';

        if (actStatus === 1) {
            return <NextImage src={pic} alt={title} aria-label={title} />;
        }

        return (
            <NextImage
                src={require(`@publicLocal/referral/${isMobile ? 'h5' : 'pc'}/${locale === 'jp' ? 'banner_jp' : 'banner'}.jpg`)}
                alt={title}
                aria-label={title}
            />
        );
    }, [actStatus, isMobile, pageUsing]);

    useEffect(() => {
        const whitelist = ['/referral', '/referral-rewards'];
        const limitedSites = ['us', 'ca'];

        if (whitelist.includes(pathname) && limitedSites.includes(locale) && actStatus === 1) {
            setIsUseBg(true);
        } else {
            setIsUseBg(false);
        }
    }, [actStatus]);

    return (
        <div id="referral-banner" className={`${styled.banner}`}>
            {BannerImage}
            <div className="banner_text">
                {isInner && (
                    <div className={`content ${isUseBg ? 'blue_bg' : ''}`}>
                        {subtitle && <p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>}
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: title }}></h1>
                        <p className="desc" dangerouslySetInnerHTML={{ __html: desc }}></p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
                {!isInner && (
                    <div className={`content ${isUseBg ? 'blue_bg' : ''}`}>
                        {subtitle && <p className="subtitle">{subtitle}</p>}
                        <h1 className="title">{title}</h1>
                        <p className="desc">{desc}</p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Banner;
